import { warn } from "../../lib/log";
import { useEffect, useRef, useState } from "react";
import { buildResultFile, buildShareText, shareResult } from "../../lib/shareResult";

// Pre-generates the PNG (debounced while the crew name is typed) so the share sheet opens within the user gesture.
// `data` must be memoized by the caller: { assignments, island, isLaughTale, crewName, quote, challenge }.
export const useResultShare = (data, destinationIndex) => {
  const [status, setStatus] = useState(null);
  const fileRef = useRef(null);

  useEffect(() => {
    let alive = true;
    fileRef.current = null;
    const t = setTimeout(() => {
      buildResultFile(data)
        .then((file) => {
          if (alive) fileRef.current = file;
        })
        .catch((e) => warn("Immagine del risultato non generata", e));
    }, 350);
    return () => {
      alive = false;
      clearTimeout(t);
    };
  }, [data]);

  const share = async () => {
    const file = fileRef.current || (await buildResultFile(data).catch(() => null));
    const result = await shareResult(file, buildShareText(data.island, data.crewName, destinationIndex));
    if (result) setStatus(result);
  };

  return { status, share };
};
